<template>
  <div>
    <el-dialog :close-on-click-modal="false" title="会员卡列表" :visible.sync="mcVisible" width="750px"
               :before-close="closeEvent">
      <div class="mc-items">
        <div class="mc-item" v-for="(item,index) in memberCards">
          <div class="mc-card">
            <img :src="item.imgUrl" class="mc-img1"/>
            <div class="mci-name">
            <span class="mci-cardname">{{item.cardName}}</span>
            <span v-if="item.cardType==0" class="mci-cardms"> (储值卡) {{item.deptName}}</span>
            <span v-if="item.cardType==1" class="mci-cardms">(年卡) {{item.deptName}}</span>
            <span v-if="item.cardType==2" class="mci-cardms">(消费卡) {{item.deptName}}</span>
            </div>
            <span class="mci-price">¥ {{item.balance}} <span style="float: right;margin-right: 5px">赠 ¥ {{item.giveBalance}}</span></span>
          </div>
          <div style="display: flex;flex-direction: row">
            <span class="mc-cz" v-if="item.id==memberCardId">当前会员卡</span>
            <span class="mc-cz" style=" cursor: pointer;" v-if="item.id!=memberCardId" @click="setMemberCard(item)">选择会员卡</span>
            <span class="mc-cz" style="margin-left: 8px; cursor: pointer;background-color: #00ACEF;color: #ffffff"
                  @click="toRecharge(item)">充值</span>
          </div>
        </div>
      </div>
    </el-dialog>
    <Recharge
      v-if="payVisible"
      :payVisible="payVisible"
      :memberCard="memberCard"
      :member="member"
      @fanhui="fanhui"
      @closePay="closePay"
    />
  </div>
</template>
<script>
  import Recharge from "./recharge";

  export default {
    components: {
      Recharge,
    },
    data() {
      return {
        payVisible: false,
        memberCard: {},
        memberCards:[],
      }
    },
    props: {
      mcVisible: Boolean,
      memberCardId:String,
      memberId:String,
      member:Object
    },

    created() {
      this.getMemberCards()
    },

    methods: {
      //获取会员信息
      async getMemberCards() {
        let res = await this.$get("/sw/getSwMbmberCards", {memberId: this.memberId});
        if (res.memberCards.length>0) {
          this.memberCards = res.memberCards
        }
      },
      closeEvent() {
        this.$emit('closeMC')
      },
      czEvent() {
        this.payVisible = false
      },
      closePay() {
        this.$message.success("充值成功")
        this.payVisible = false
        this.$emit('recharge')
      },
      fanhui() {
        this.payVisible = false
      },
      toRecharge(item) {
        this.memberCard = item
        this.payVisible = true
      },

      setMemberCard(item) {
        this.$emit('setMc', item)
      },
    }
  }
</script>
<style lang="scss">
  .mc-items {
    width: 100%;
    margin-top: -18px;
    display: flex;
    flex-flow: row wrap;
    margin-bottom: 18px;
    height: 380px;
    overflow: auto;
  }

  .mc-item {
    flex: 1;
    box-sizing: border-box;
    height: 168px;
    padding: 8px;
    margin-bottom: 38px;
    width: calc(100% / 3); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
    min-width: calc(100% / 3);
    max-width: calc(100% / 3);
    &:nth-child(3n + 3) {
      margin-right: 0px;
    }
  }

  .mc-card {
    display: flex;
    flex-direction: column;
  }

  .mc-img1 {
    width: 100%;
    height: 120px;
    border-radius: 3px;
  }

  .mci-name {
    margin-top: 3px;
    line-height: 16px;
    margin-left: 5px;
    font-size: 10px;
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    text-overflow: ellipsis;
    box-sizing: border-box;
  }
  .mci-cardname {
    flex: none;
  }
  .mci-cardms {
    flex: 1;
    color:#A2A2A2;
    font-size: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mci-price {
    line-height: 16px;
    margin-left: 5px;
    color: red;
    font-size: 10px;
  }

  .mc-cz {
    width: 50%;
    text-align: center;
    margin-top: 6px;
    height: 20px;
    line-height: 20px;
    border: #DFDFDF solid 1px;
    font-size: 11px;
  }

</style>
